import { render, staticRenderFns } from "./QuestionnaireRegister.vue?vue&type=template&id=4ac57fbf&scoped=true&lang=pug"
import script from "./QuestionnaireRegister.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireRegister.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireRegister.vue?vue&type=style&index=0&id=4ac57fbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac57fbf",
  null
  
)

export default component.exports